'use client'

import React from 'react';
import { StyledPlatofrmHero } from './howToInstallHero.styles';
import { IPlatform, IPlugin } from '../../types';
import { WidgetNavbar } from '../widgetNavbar/widgetNavbar.comp';
import { CustomLink } from '../link/link.comp';
import { Header } from '../header/header.comp';

interface IHowToInstallHeroProps {
    platform?: IPlatform;
    app: IPlugin;
}

export const HowToInstallHero = ({ platform, app }: IHowToInstallHeroProps) => {
    const title = platform ? `How to add ${app.name} to a ${platform.title} ${platform.siteSynonym}` : `How to add ${app.name} to your website`;
    const subTitle = platform ? `Embed ${app.name} on ${platform.title} in just a few steps` : `Embed ${app.name} on your website in just a few steps`;

    return (
        <StyledPlatofrmHero>
            <Header
                fixedPosition={true}
                style={{ background: 'transparent', paddingRight: '0', paddingLeft: '0' }}
            />
            <WidgetNavbar
                widget={app}
                platform={platform}
            />
            <div className="hero-wrapper">
                <h1>{title}</h1>
                <h2>{subTitle}</h2>
                <div className="button-wrapper">
                    <CustomLink
                        variant='gradient'
                        external
                        title={`${app.buttonText} ${platform ? `for ${platform.title}` : ''
                            }`}
                        className="try-button"
                        id="main-create-widget-cta"
                        href={`/${app.slug}/editor`}
                        onClick={() => {
                            // trackEvent(`Landing page ${widget.name}${platform ? ' ' + platform.title : ''}`, { serviceName: widget.serviceName });
                        }}
                    >
                        {app.buttonText}
                    </CustomLink>
                </div>
            </div>
        </StyledPlatofrmHero>
    );
};
